import type { RootState } from 'reducers/types';

export const entityHasErrors = (state: RootState, entity: string) => {
  const {
    entities: { errors },
  } = state;

  return errors.includes(entity);
};
